import { format as formatWithTimezone } from "date-fns-tz";

import { locale } from "./datetime";

/**
 * ✅ This is part of the Cadmus standardised date/duration formatting.
 * Format the date to a full sentence with its timezone.
 * @example "4 May at 12:00 AM AEST"
 * @param date The date to format
 */
export function formatFullSentenceWithoutDay(date: Date): string {
  return formatWithTimezone(date, "dd MMMM yyyy 'at' h:mm a zzz", {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: locale,
  });
}
